export default __webpack_public_path__ + "static/media/logo.5b00f2a4.svg";